import type { SuggestionFilter } from './tabTakesSuggestion';

/**
 * The filter of a vocabulary whose terms carry a short gloss: an option is
 * found by its gloss as well as by its own words.
 */
export function hintsFilter(hints: Record<string, string>): SuggestionFilter {
    return (candidates, state) => {
        const query = state.inputValue.toLowerCase();
        return candidates.filter((option) =>
            `${option} ${hints[option] ?? ''}`.toLowerCase().includes(query)
        );
    };
}
